import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import OurIdentityImg1 from "../../assets/iden-img1.jpg";
import AboutInvestingImg1 from "../../assets/iden-img2.jpg";
import * as apiUrl from "../../apiUrl";

function OurIdentityDescription({ seconddata, thirddata, fourthdata }) {
  const second_section_descriptions = seconddata.section_description
    ? JSON.parse(seconddata.section_description)
    : [];

  const fourth_section_descriptions = fourthdata.section_description
    ? JSON.parse(fourthdata.section_description)
    : [];
  return (
    <section className="privacy-description-sec about-inner-page-desc">
      <Container fluid>
        <Row className="flex-center about-our-identity-row">
          <Col md={6}>
            <img
              src={apiUrl.apiUrl + `/` + seconddata.section_image}
              className="img-fluid"
              alt="Marquis Dubai"
              data-aos="fade-right"
            />
          </Col>
          <Col md={6}>
            <div className="about-investing-content-div" data-aos="fade-left">
              <h2 className="common-head goldenColor" dangerouslySetInnerHTML={{ __html: seconddata.section_title }}>                
              </h2>
              {second_section_descriptions.map((desc, index) => (
                <p className="common-para">{desc}</p>
              ))}
            </div>
          </Col>
        </Row>
      </Container>

      <Container fluid className="wrap identity-new-page-container">
        <Row>
          <Col md={12}>
            <div
              className="privacy-desc-div"
              dangerouslySetInnerHTML={{ __html: thirddata.description }}
            >             
            </div>
          </Col>
        </Row>
      </Container>

      <Container fluid className="about-investing-container">
        <Row className="flex-center about-investing-row">
          <Col md={6}>
            <div className="about-investing-content-div" data-aos="fade-right">
              <h2 className="common-head goldenColor"  dangerouslySetInnerHTML={{ __html: fourthdata.section_title }}>                
              </h2>
              {fourth_section_descriptions.map((desc, index) => (
                <p className="common-para">{desc}</p>
              ))}
            </div>
          </Col>
          <Col md={6}>
            <img
              src={apiUrl.apiUrl + `/` + fourthdata.section_image}
              className="img-fluid"
              alt="Marquis Real Estate Developer in Dubai"
              data-aos="fade-left"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}
export default OurIdentityDescription;
